<header class="o-widget__header">
  <h1 class="o-widget__heading">Anstehende Erinnerungen</h1>
  <p class="o-widget__subline">Aufgaben die zu erledigen sind von mir</p>
</header>
<div class="o-widget__body">
  <p>Schaden der einzelnen Unternehmen</p>
  <p>Warnung, wenn Konzern gefährdet ist</p>
</div>
